import { useContext } from 'react';

import { Theme } from 'context';

const useTheme = () => useContext(Theme.Context);

export default useTheme;
